// Lucide icon: shopping-cart (https://lucide.dev/icons/shopping-cart)
import { ShoppingCart } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconCart = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ShoppingCart />
    </IconComponentStyled>
  )
}
